import {
  ADD_TO_QUE,
  PLAY_PLAYLIST,
  CLEAR_QUE,
  // ADD_TO_PLAYLIST,
  DELETE_PLAYLIST,
} from "../types"
import { Track } from "../../models/track"
import { Dispatch } from "redux"

export const addToQue = (payload: Track) => (dispatch: Dispatch) => {
  dispatch({
    type: ADD_TO_QUE,
    payload,
  })
}

export const playPlaylist = (payload: Track[]) => (dispatch: Dispatch) => {
  dispatch({
    type: PLAY_PLAYLIST,
    payload: payload,
  })
}

export const clearQue = () => (dispatch: Dispatch) => {
  dispatch({
    type: CLEAR_QUE,
  })
}

export const deletePlaylist = (id: string) => (dispatch: Dispatch) => {
  dispatch({
    type: DELETE_PLAYLIST,
    payload: id,
  })
}
